(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6249],{

/***/ 81570:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/e-commerce-tour/[...slug]",
      function () {
        return __webpack_require__(55267);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 55267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_common_PageHeader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96311);
/* harmony import */ var _components_common_LoadingProgress__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52641);
/* eslint-disable prefer-destructuring */ 




var DynamicComponent3WithNoSSR = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3737), __webpack_require__.e(952), __webpack_require__.e(7208), __webpack_require__.e(9198), __webpack_require__.e(8293), __webpack_require__.e(7845), __webpack_require__.e(745), __webpack_require__.e(989), __webpack_require__.e(5621), __webpack_require__.e(2816), __webpack_require__.e(736)]).then(__webpack_require__.bind(__webpack_require__, 40736));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(40736)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_LoadingProgress__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {});
    },
    ssr: false
});
var getParams = function(slug) {
    var matterId;
    var videoType;
    var rule;
    var room;
    var renderType = 2;
    // renderType
    // 0 : /e-commerce-tour/:mattterId
    // 1 : /token/:token
    // 2 : /e-commerce-tour/:slug/:videoType/:rule/:chatToken
    if (slug.length === 1 || slug.length > 1 && slug[1] === "processOrder" || slug.length > 1 && slug[1] === "book" || slug.length > 1 && slug[1] === "login") {
        matterId = slug[0];
        renderType = 0;
    } else if (slug.length === 4) {
        matterId = slug[0];
        videoType = slug[1];
        rule = slug[2];
        room = slug[3];
        renderType = 2;
    // eslint-disable-next-line no-console
    } else console.log("Wrong url, ask Boaz how to behave");
    return {
        matterId: matterId,
        videoType: videoType,
        rule: rule,
        room: room,
        renderType: renderType
    };
};
var IndexPage = function(param) {
    var data = param.data;
    var ref = JSON.parse(data), title = ref.title, description = ref.description, tourImage = ref.tourImage, website = ref.website, fbPixel = ref.fbPixel, fbAppId = ref.fbAppId, faviconUrl = ref.faviconUrl, htmlCode = ref.htmlCode, tourData = ref.tourData, tags = ref.tags, matterTags = ref.matterTags, charset = ref.charset;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var slug = router.query.slug;
    if (!slug) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_LoadingProgress__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {});
    var ref1 = getParams(router.query.slug), matterId = ref1.matterId, videoType = ref1.videoType, rule = ref1.rule, room = ref1.room, renderType = ref1.renderType;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_PageHeader__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        title: title,
        description: description,
        slug: matterId,
        tourImage: tourImage,
        website: website,
        fbPixel: fbPixel,
        fbAppId: fbAppId,
        faviconUrl: faviconUrl,
        htmlCode: htmlCode,
        type: "e-commerce-tour",
        charset: charset,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DynamicComponent3WithNoSSR, {
            tourData: tourData,
            tags: tags,
            matterTags: matterTags,
            renderType: renderType,
            matterId: matterId,
            videoType: videoType,
            rule: rule,
            room: room,
            reactAws: "https://cdn.treedis.com",
            reactAppDomain: "https://api.treedis.com",
            reactAppMatterPort: "295ba0c0f04541318359a8e75af33043",
            reactPaypalClient: "AcYyCJIK1tv2azUW4suLJ7ekxPN-UiaM2JSRUdryWCpKMOYzH7yDhg073Ybp33832j3_feVg3NA9aAZc"
        })
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (IndexPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3627,9774,2888,179], function() { return __webpack_exec__(81570); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);